<!-- Recovery Component HTML -->

<div
    [@showOpacityAnimation]="animState"
    (@showOpacityAnimation.done)="whenAnimate($event)"
    class="recovery__wrapper"
>
    <div
        *ngIf="
            newPasswordForm.controls['newPW2'].hasError('passwordMismatch') &&
            (newPasswordForm.controls['newPW2'].dirty ||
                newPasswordForm.controls['newPW2'].touched)
        "
        class="error-message"
    >
        Пароли не совпадают.
    </div>

    <form
        class="reg-form"
        [formGroup]="newPasswordForm"
        *ngIf="!isTokenRecovery"
    >
        <div class="loading-group">
            <div *ngIf="loading" class="loading">
                <loader type="page"> </loader>
            </div>
            <!-- [type]="'text'" -->
            <mat-form-field class="w-100">
                <input
                    type="{{ newPassHidden ? 'text' : 'password' }}"
                    matInput
                    formControlName="newPW"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="true"
                />
                <mat-label>Новый пароль</mat-label>
                <span
                    matSuffix
                    (click)="newPassHiddenHandler()"
                    class="hidden__button"
                >
                    <mat-icon
                        [svgIcon]="
                            newPassHidden ? 'visibility' : 'visibility_off'
                        "
                    ></mat-icon>
                </span>
            </mat-form-field>
            <!-- [type]="'text'" -->
            <mat-form-field class="w-100">
                <input
                    type="{{ newPassHiddenConfirm ? 'text' : 'password' }}"
                    matInput
                    formControlName="newPW2"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="true"
                />
                <mat-label>Повтор нового пароля</mat-label>
                <span
                    matSuffix
                    (click)="newPassHiddenHandlerConfirm()"
                    class="hidden__button"
                >
                    <mat-icon
                        [svgIcon]="
                            newPassHiddenConfirm
                                ? 'visibility'
                                : 'visibility_off'
                        "
                    ></mat-icon>
                </span>
            </mat-form-field>

            <button
                class="w-100 btn btn-lg cls-btn cls-btn-reg"
                type="submit"
                [disabled]="loading || newPasswordForm.invalid"
                (click)="goRecoveryNewPW()"
            >
                Сменить
            </button>

            <div class="cls-txt-center cls-footer1">Есть аккаунт?</div>
            <div
                class="cls-txt-center cls-footer2"
                (click)="goAuth()"
                *ngIf="AccessReg"
                placeholder="Регистрация"
            >
                Войти
            </div>
        </div>
    </form>

    <form class="reg-form" [formGroup]="recoveryForm" *ngIf="isTokenRecovery">
        <div class="loading-group">
            <div *ngIf="loading" class="loading">
                <loader type="page"> </loader>
            </div>

            <mat-form-field class="w-100">
                <input
                    [type]="'text'"
                    matInput
                    formControlName="lastName"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="true"
                />
                <mat-label>Фамилия</mat-label>
            </mat-form-field>

            <mat-form-field class="w-100">
                <input
                    [type]="'text'"
                    matInput
                    formControlName="firstName"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="true"
                />
                <mat-label>Имя</mat-label>
            </mat-form-field>

            <mat-form-field class="w-100">
                <input
                    [type]="'text'"
                    matInput
                    formControlName="secondName"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="false"
                />
                <mat-label>Отчество</mat-label>
            </mat-form-field>

            <mat-form-field class="w-100">
                <input
                    type="date"
                    matInput
                    formControlName="birthDate"
                    required="true"
                    [max]="maxDate"
                    [readonly]="loading"
                    (keypress)="formatDate($event)"
                />
                <mat-label>Дата рождения</mat-label>
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>Почта</mat-label>
                <input
                    [type]="'text'"
                    matInput
                    formControlName="email"
                    placeholder="guest@mail.ru"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="true"
                />
            </mat-form-field>

            <div class="phone__captcha captcha">
                <div class="captcha__left">
                    <mat-form-field class="input">
                        <input
                            type="number"
                            id="regcaptha"
                            matInput
                            placeholder="Введите код с картинки"
                            maxlength="4"
                            formControlName="captcha"
                            [readonly]="loading"
                            (keydown.space)="$event.preventDefault()"
                            required
                            (keypress)="numberOnly($event)"
                        />
                    </mat-form-field>
                </div>
                <div class="captcha__right">
                    <div
                        *ngIf="captcha; else captchaLoader"
                        class="captcha-content"
                    >
                        <!-- Контейнер для SVG капчи -->
                        <div
                            class="captcha__img"
                            [innerHTML]="captcha.svg | safe : 'html'"
                        ></div>

                        <!-- Кнопка обновления капчи -->
                        <button
                            class="captcha__refresh"
                            type="button"
                            (click)="refreshCaptcha()"
                        >
                            <mat-icon svgIcon="refresh"></mat-icon>
                        </button>
                    </div>

                    <ng-template #captchaLoader>
                        <div class="loader-wrapper">
                            <span class="loader"></span>
                        </div>
                    </ng-template>
                </div>
            </div>

            <button
                class="w-100 btn btn-lg cls-btn cls-btn-reg"
                type="submit"
                [disabled]="loading || !recoveryForm.valid"
                (click)="goRecovery()"
            >
                Восстановить
            </button>

            <div class="cls-txt-center cls-footer1">Есть аккаунт?</div>
            <div
                class="cls-txt-center cls-footer2"
                (click)="goAuth()"
                placeholder="Регистрация"
            >
                Войти
            </div>
        </div>
    </form>
</div>
